import {PHASES, WAR_PHASE_STAGES} from "../../constants/phases";
import {checkIfOnWorkingBarracks} from "../gameState/checkIfOnWorkingBarracks";

export const isUnitSizeRecruitmentMarkersShown = (
  phase,
  warPhaseStage,
  selectedUnitId,
  hexes,
  specialBuildings,
  player,
  citiesCache,
  units,
  buildingsDamage,
) => {
  const isShownIfOnWorkingBarracks = phase === PHASES.WAR
    && warPhaseStage === WAR_PHASE_STAGES.RECRUITMENT
    && !!selectedUnitId;

  if (!isShownIfOnWorkingBarracks) {
    return false;
  }

  const selectedUnit = units.find(u => u.id === selectedUnitId);

  return checkIfOnWorkingBarracks(
    selectedUnit.hexKey, hexes, specialBuildings, player, citiesCache, units, buildingsDamage
  );
}